import { useNavigate } from "react-router-dom";
import { useCallback, useContext, useState } from "react";

import { CustomerContext } from "../../providers";
import { OverflowFrame, PageHeading } from "../../externalComponents";

import { Button } from "../../externalComponents/tailwind/button";
import { Text } from "../../externalComponents/tailwind/text";
import { DuplicateCampaignOrAutomation } from "../../externalComponents/DuplicateCampaignOrAutomation";

export default function DuplicatePage() {
  const navigate = useNavigate();
  const { user, customer, shop } = useContext(CustomerContext);

  return <DuplicateCampaignOrAutomation />;
}
